import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import StatusPill from "@/components/StatusPill";
import { Button } from "@/components/ui/button";
import api from "@/lib/api";
import { toast } from "sonner";
import { ArrowUpRight, Package, ArrowClockwise } from "@phosphor-icons/react";

export default function Orders() {
  const [orders, setOrders] = useState([]);
  const navigate = useNavigate();
  useEffect(() => {
    api.get("/orders").then((r) => setOrders(r.data.items || []));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const reorder = async (id) => {
    const { data } = await api.post(`/orders/${id}/reorder`);
    toast.success("Draft created from this order");
    navigate(`/requests/${data.request_id}`);
  };
  return (
    <div className="App min-h-screen">
      <Navbar />
      <div className="max-w-6xl mx-auto px-6 lg:px-8 py-10">
        <div className="text-xs tracking-widest-2 uppercase text-muted-foreground font-semibold mb-2">Orders</div>
        <h1 className="font-heading font-black tracking-tighter text-4xl md:text-5xl mb-8">Your orders.</h1>
        {orders.length === 0 && <div className="text-sm text-muted-foreground">No orders yet.</div>}
        <div className="space-y-3">
          {orders.map((o) => (
            <div key={o.order_id} className="border border-border bg-white p-5 flex items-center justify-between gap-4">
              <Link to={`/orders/${o.order_id}`} className="flex-1 min-w-0">
                <div className="flex items-center gap-3 mb-1">
                  <Package size={16} className="text-muted-foreground" />
                  <span className="font-mono text-[11px] text-muted-foreground">{o.reference}</span>
                  <StatusPill status={o.status} />
                </div>
                <div className="font-semibold text-lg">{o.currency} {o.amount?.toLocaleString()}</div>
                <div className="text-xs text-muted-foreground">Option: {o.option_key} · Placed {new Date(o.created_at).toLocaleDateString()}</div>
              </Link>
              <div className="flex items-center gap-2">
                <Button size="sm" variant="outline" className="rounded-sm" onClick={() => reorder(o.order_id)} data-testid={`orders-reorder-${o.order_id}`}>
                  <ArrowClockwise size={14} className="mr-1" /> Reorder
                </Button>
                <Link to={`/orders/${o.order_id}`} className="text-primary text-sm inline-flex items-center gap-1 hover:underline">
                  Open <ArrowUpRight size={14} />
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
}

